<template>
  <p v-bind="$attrs" :class="textClass">
    <slot></slot>
  </p>
</template>

<script>
export default {
  props: {
    bold: { type: Boolean, default: false }
  },
  computed: {
    textClass () {
      return 'text-subtitle-1 ' + (this.bold ? 'font-weight-medium' : '')
    }
  }
}
</script>
